<template>
  <div :class="classes">
    <asd20-list
      v-if="days.length > 0"
      :headline="title || headline"
      :icon="icon"
      :max-height="maxHeight"
    >
      <template v-for="day in days">
        <asd20-list-category
          :key="day.unix"
          :label="`${day.weekday}, ${day.month} ${day.shortDay}, ${day.year}`"
        />
        <asd20-list-item v-for="event in day.events" :key="event.uid" condensed>
          <asd20-calendar-event-button
            :event="event"
            large
            @click.native="selectedEvent = event"
          />
        </asd20-list-item>
      </template>
    </asd20-list>
    <Asd20EventModal
      :event="selectedEvent"
      :open="!!selectedEvent"
      @dismiss="selectedEvent = null"
    />
  </div>
</template>

<script>
import Asd20CalendarEventButton from '../../../components/atoms/Asd20CalendarEventButton'
import Asd20List from '../../../components/organisms/Asd20List'
import Asd20ListItem from '../../../components/molecules/Asd20ListItem'
import Asd20ListCategory from '../../../components/molecules/Asd20ListCategory'
import Asd20EventModal from '../../../components/organisms/Asd20EventModal'
import mapEventsToDays from '../../../helpers/mapEventsToDays'
import expandEvents from '../../../helpers/expandEvents'

export default {
  name: 'Asd20EventList',

  components: {
    Asd20CalendarEventButton,
    Asd20List,
    Asd20ListItem,
    Asd20ListCategory,
    Asd20EventModal,
  },

  props: {
    events: { type: Array, default: () => [] },
    headline: { type: String, default: '' },
    title: { type: String, default: '' },
    icon: { type: String, default: '' },
    maxHeight: { type: String, default: '450px' },
    large: { type: Boolean, default: false },
    hidePastEvents: { type: Boolean, default: false },
  },

  data: () => ({
    selectedEvent: null,
  }),

  computed: {
    classes() {
      return {
        'asd20-event-list': true,
        'asd20-event-list--large': this.large,
      }
    },
    days() {
      if (!this.events) return []
      let events = this.events.map(e => ({
        ...e,
        start: e.start,
        end: e.end ? e.end : null,
      }))

      if (this.hidePastEvents) {
        events = events.filter(e => {
          const today = new Date()
          const start = new Date(e.start)
          const end = new Date(e.end)
          return end >= today || start >= today
        })
      }

      return mapEventsToDays(expandEvents(events), 0, 0, true)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';

@media (min-width: 1024px) {
  .asd20-event-list {
    &::v-deep .asd20-list > .asd20-list__items {
      padding-left: space(0.5);
    }
    &--large {
      &::v-deep .asd20-list .asd20-list-category {
        border-bottom: 1px solid var(--color__tertiary);
      }
      &::v-deep .asd20-list .asd20-list-category__label {
        font-size: 1rem;
      }
      &::v-deep .asd20-list .asd20-list-item {
        padding: space(0.5);
      }
      &::v-deep .asd20-list .asd20-list-item + .asd20-list-item {
        padding-top: space(0.25);
        margin-top: space(-0.5);
      }
      &::v-deep .asd20-list .asd20-calendar-event-button .title::before {
        width: 10px;
        height: 10px;
      }
    }
  }
}
</style>
